import { ConnectionInfo } from "utils/serverless-hub";
import { defaultErrorResponse } from "./defaults";
import { API } from "utils/api-config";

export const loadConnectionInfo = async (
    userId: string,
    habName: string
): Promise<[ConnectionInfo | null, number]> => {
    if (!userId) {
        return defaultErrorResponse;
    }

    const response = await API.get("hub/connection", {
        headers: {
            "x-ms-signalr-hub-name": habName,
            "x-ms-signalr-userid": userId,
        },
    });

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
